import type { ComponentProps } from "react";

import { Skeleton } from "../skeleton";
import { cn } from "../utils";

type Props = ComponentProps<typeof Skeleton>;

function InputSkeleton({ className, ...props }: Props) {
  return <Skeleton className={cn("h-9", className)} {...props} />;
}

export { InputSkeleton };
